/* Polsk katalog for locale-demo-reset-shortcut.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'demoReset.button': 'Zresetuj demo',
  'demoReset.title': 'Zresetuj firmę demonstracyjną',
  'demoReset.message': 'Spowoduje to trwałe usunięcie wszystkich danych księgowych i operacyjnych tej firmy demonstracyjnej. Tej operacji nie można cofnąć.',
  'demoReset.preserved': 'Profil firmy, członkowie, subskrypcja i połączenia integracji zostaną zachowane.',
  'demoReset.phrase': 'POTWIERDZAM',
  'demoReset.typeLabel': 'Wpisz {phrase}, aby włączyć reset',
  'demoReset.typeHint': 'Przed kontynuowaniem sprawdź, czy wybrano właściwą firmę demonstracyjną.',
  'demoReset.confirm': 'Usuń i zresetuj demo',
  'demoReset.complete': 'Firma demonstracyjna została zresetowana.',
  'demoReset.failed': 'Nie udało się zresetować firmy demonstracyjnej.',
  'demoReset.reason': 'Użytkownik potwierdził szybki reset firmy demonstracyjnej, wpisując wymagane słowo potwierdzające.',
  'demoReset.settingTitle': 'Pokaż przycisk szybkiego resetu',
  'demoReset.settingHelp': 'Pokazuje „Zresetuj demo” nad SuperPlumma dla tej firmy. Inne firmy na koncie demonstracyjnym są konfigurowane osobno.',
  'demoReset.settingEnabled': 'Przycisk szybkiego resetu jest włączony dla tej firmy demonstracyjnej.',
  'demoReset.settingDisabled': 'Przycisk szybkiego resetu jest wyłączony.',
});
